export default {
  "member": "Socio",
  "staff": "Personale",
  "external": "Esterno",
  "unableToLoadBoardMembers": "Incapace di caricare i membri della scheda",
  "pleaseTryAgainShortly": "Vi prego di riprovare a breve.",
  "pleaseUploadAnImageFile": "Si prega di caricare un file immagine.",
  "imageMustBe5MBOrSmaller": "L'immagine deve essere 5MB o più piccola.",
  "nameIsRequired": "Il nome è richiesto.",
  "pleaseSelectAMemberFromSearch": "Si prega di selezionare un socio dalla ricerca.",
  "pleaseSelectAStaffRecordFromSearch": "Si prega di selezionare un record personale dalla ricerca.",
  "enterAValidEmailAddress": "Inserisci un indirizzo email valido.",
  "boardMemberAdded": "Membro del consiglio aggiunto",
  "theRosterHasBeenUpdatedSuccessfully": "Il gallo è stato aggiornato con successo.",
  "unableToAddBoardMember": "Incapace di aggiungere membro del consiglio",
  "pleaseReviewTheDetailsAndTryAgain": "Si prega di rivedere i dettagli e riprovare.",
  "unableToUpdateStatus": "Non è possibile aggiornare lo stato",
  "pleaseTryAgain": "Riprova.",
  "roleTitleIsTooLong": "Il titolo di Role è troppo lungo",
  "roleTitleMustBe80CharactersOrFewer": "Il titolo del ruolo deve essere di 80 caratteri o meno.",
  "roleUpdated": "Role aggiornato",
  "boardMemberRoleHasBeenUpdated": "Il ruolo del membro del consiglio è stato aggiornato.",
  "unableToUpdateRole": "Incapace di aggiornare il ruolo",
  "boardMemberRemoved": "Membro del consiglio rimosso",
  "theBoardRosterHasBeenUpdated": "Il roster di bordo è stato aggiornato.",
  "unableToRemoveBoardMember": "Incapace di rimuovere il membro del bordo",
  "roster": "Turni del personale",
  "boardMembers": "Membri del consiglio",
  "manageTheDirectorsOfficersAndExternalAdvisorsWhoShapeGovernanceDecisions": "Gestire i direttori, gli ufficiali e i consulenti esterni che modellano le decisioni di governance.",
  "addBoardMember": "Aggiungi membro del consiglio",
  "buildYourGovernanceRoster": "Costruisci il tuo roster di governance",
  "addBoardDirectorsStaffLiaisonsOrExternalAdvisorsToPrepareForSecureVoting": "Aggiungi consiglieri, colleghi del personale o consulenti esterni per prepararsi al voto sicuro.",
  "trackMemberTypeRoleTitlesAndAccessStatusInOnePremiumRoster": "Traccia il tipo di socio, i titoli di ruolo e lo stato di accesso in un roster premium.",
  "activeRoster": "Roster attivo",
  "keepTheBoardRosterCurrentForSecureGovernanceAndFutureVotingWorkflows": "Mantenere la corrente di roster del consiglio per la governance sicura e i flussi di lavoro di voto futuri.",
  "role": "Ruolo",
  "type": "Tipo",
  "contact": "Contatto",
  "status": "Stato",
  "actions": "Azioni",
  "boardMember": "Membro del consiglio",
  "active": "Attivo",
  "inactive": "Inattivo",
  "boardMemberActions": "Azioni dei membri del Consiglio",
  "editRole": "Modifica ruolo",
  "delete": "Elimina",
  "memberType": "Tipo di socio",
  "selectType": "Selezionare il tipo",
  "selectFromTheMemberDirectory": "Seleziona dall'elenco dei soci.",
  "selectFromTheStaffDirectory": "Selezionare dalla directory del personale.",
  "enterManuallyAndOptionallyUploadAnAvatar": "Inserire manualmente e facoltativamente caricare un avatar.",
  "roleTitle": "Titolo di Role",
  "chairTreasurer": "Sedia, Tesoriere",
  "name": "Nome",
  "searchStaffNameOrEmail": "Cerca nome del personale o e-mail",
  "searchMemberNameOr": "Nome del socio di ricerca o #",
  "clearSelection": "Selezione chiara",
  "type2CharactersToSearch": "Digitare 2+ caratteri per la ricerca",
  "loading": "Caricamento…",
  "noResults": "Nessun risultato",
  "janeCarter": "Jane Carter",
  "email": "E-mail",
  "optionalDirectorySelectionCanPrefillThis": "Facoltativo. La selezione di directory può preriempire questo.",
  "avatarImage": "Immagine di Avatar",
  "avatarPreview": "Anteprima Avatar",
  "uploadJPGPNGGIFOrWebPUpTo5MB": "Carica JPG, PNG, GIF o WebP fino a 5MB.",
  "clearUploadedOverride": "Cancella override caricata",
  "boardMemberRecordsAreScopedToThisClubTenant": "I registri dei membri del consiglio sono indirizzati a questo inquilino del club.",
  "cancel": "Annulla",
  "saving": "Salvataggio…",
  "addMember": "Aggiungi un socio",
  "memberAvatar": "Avatar socio",
  "avatarUnavailable": "Avatar non disponibile",
  "close": "Chiudi",
  "upTo80CharactersLeaveEmptyToClear": "Fino a 80 caratteri. Lasciare vuoto per liberare.",
  "save": "Salva",
  "removeBoardMember": "Rimozione del membro del consiglio?",
  "thisCanBeUndoneByAnAdmin": "Questo può essere annullato da un amministratore.",
  "removing": "Rimozione...",
  "remove": "Rimuovi",
  "revenue": "Ricavi",
  "expenses": "Spese",
  "yTDRevenue": "Ytd ricavi",
  "memberEngagement": "Engagement",
  "activeMembersThisMonth": "soci attivi questo mese",
  "openSafetyIncidents": "Incidenti di sicurezza aperti",
  "requiresBoardReview": "Require la recensione della scheda",
  "financialOverview": "Panoramica finanziaria",
  "revenueBreakdown": "Ripartizione delle entrate",
  "noRevenueDataYet": "Nessun dato di reddito",
  "monthlyRevenueTrend": "Tendenza mensile delle entrate",
  "noMonthlyRevenueDataYet": "Nessun dato mensile di fatturato",
  "topExpenseCategories": "Top Expense Categorie",
  "noExpenseDataYet": "Nessun dato di spesa ancora",
  "nA": "N/A",
  "noDecisionsRequiringAction": "Nessuna decisione che richieda un'azione",
  "whenNewMotionsAreSubmittedTheyWillAppearHere": "Quando verranno presentate nuove mozioni, appariranno qui.",
  "noPriorComparisonAvailable": "Nessun confronto preventivo disponibile",
  "decisionSpotlight": "Obiettivo della decisione",
  "budgetApproval": "Approvazione del bilancio",
  "totalBudget": "Totale bilancio",
  "monthlyAverage": "Media mensile",
  "varianceVsPrior": "Scostamento rispetto al periodo precedente",
  "error": "Errore",
  "validationError": "Errore di convalida",
  "pleaseSelectAFileAndEnterACategory": "Seleziona un file e inserisci una categoria.",
  "success": "Successo",
  "documentUploadedSuccessfully": "Documento caricato con successo.",
  "areYouSureYouWantToDeleteThisDocument": "Sei sicuro di voler eliminare questo documento?",
  "documentDeletedSuccessfully": "Documento cancellato con successo.",
  "documentsAndPolicies": "Documenti e politiche",
  "searchDocuments": "Ricerca documenti...",
  "documentCategory": "Categoria Documenti",
  "chooseFile": "Scegli il file",
  "uploading": "Caricamento...",
  "uploadDocument": "Documento di caricamento",
  "category": "Categoria",
  "version": "Versione",
  "lastUpdated": "Ultimo aggiornamento",
  "loadingDocuments": "Caricamento documenti...",
  "download": "Scarica",
  "noDocumentsFound": "Nessun documento trovato.",
  "failedToLoadDocuments": "Non ha caricato i documenti.",
  "failedToUploadDocument": "Non ha caricato il documento.",
  "failedToDeleteDocument": "Non è riuscito a cancellare il documento.",
  "meetings": "Incontri",
  "createMeeting": "Creare una riunione",
  "upcomingMeetings": "Prossimi incontri",
  "pleaseSelectAClubToViewMeetings": "Si prega di selezionare un club per visualizzare gli incontri.",
  "attendees": "partecipanti",
  "viewDetails": "Visualizza dettagli",
  "noUpcomingMeetingsScheduled": "Non ci sono incontri in programma.",
  "pastMeetings": "Incontri passati",
  "pleaseSelectAClubToViewPastMeetings": "Si prega di selezionare un club per visualizzare gli incontri precedenti.",
  "viewMinutes": "Visualizza processo verbale",
  "noPastMeetingsFound": "Nessun precedente incontro trovato.",
  "notYetOpenForVoting": "Non ancora aperto al voto",
  "pendingForOpenVoting": "Prestiti per voto aperto",
  "votingInProgress": "Votazione in corso",
  "votingCompleted": "Votazione completata",
  "submissionWithdrawn": "Ritiro della sottomissione",
  "boardDecision": "Decisione del Consiglio",
  "created": "Creato",
  "createdBy": "Creato da",
  "boardSecretariat": "Segretariato del Consiglio",
  "yes": "Sì",
  "no": "No",
  "abstain": "Astieniti",
  "youVoted": "Tu hai votato",
  "outcome": "Risultato:",
  "review": "Recensione",
  "openVoting": "Votazione aperta",
  "pendingForOpen": "In attesa di apertura",
  "thisMotionIsQueuedForVotingOnceLeadershipOpensTheBallotWindow": "Questa mozione è in coda per votare una volta che la leadership apre la finestra di scheda elettorale.",
  "closes": "Chiude",
  "boardPackSummary": "Riepilogo del pacchetto",
  "allocationByDepartment": "Delocalizzazione per reparto",
  "noAllocationDataAvailable": "Non sono disponibili dati di allocazione.",
  "whatChangedVsLastYear": "Che cosa è cambiato vs l'anno scorso?",
  "noPriorVersionFound": "Nessuna versione precedente trovata.",
  "overallVariance": "Variazione complessiva",
  "topIncreases": "Aumento superiore",
  "noIncreasesToHighlight": "Nessun aumento da evidenziare.",
  "topDecreases": "Riduzioni superiori",
  "noDecreasesToHighlight": "Nessuna diminuzione da evidenziare.",
  "votingManagement": "Gestione dei voti",
  "openAndCloseVotingWindowsForBoardMembers": "Aprire e chiudere le finestre di voto per i membri del consiglio.",
  "resendInvites": "Invita gli inviti",
  "closeVoting": "Votazione ravvicinata",
  "governanceRecord": "Registrazione di governance",
  "unableToLoadMotionReviewData": "Non è in grado di caricare i dati della recensione del movimento.",
  "votingOpened": "Aperta la votazione",
  "boardVotingIsNowLive": "Il voto del Consiglio è ora vivo.",
  "unableToOpenVoting": "Incapace di aprire il voto",
  "inviteSent": "Invito inviato",
  "inviteRefreshed": "Invitato rinfrescato",
  "votingLinkAndOTPResent": "Votazione link e OTP risentimento.",
  "inviteTokenRefreshedForThisVoter": "Invita il token rinfrescato per questo elettore.",
  "inviteNotRequired": "Invitare non richiesto",
  "thisMemberVotesInTheMembersPortal": "Questo socio vota nel Portale dei soci.",
  "missingEmail": "E-mail mancante",
  "noEmailIsAvailableForThisBoardMember": "Nessuna e-mail è disponibile per questo membro del consiglio.",
  "unableToResendInvite": "Incapace di rend invitare",
  "votingClosed": "Votazione chiusa",
  "theResolutionHasBeenFinalized": "La risoluzione è stata completata.",
  "unableToCloseVoting": "Incapace di chiudere il voto",
  "backToVoting": "Torna a Votare",
  "motionNotFound": "Moto non trovato.",
  "motionCreated": "Moto creato",
  "motionOpened": "Movimento aperto",
  "voteRecorded": "Voto registrato",
  "motionClosed": "Movimento chiuso",
  "motionApproved": "Proposta approvata",
  "motionRejected": "Proposta respinta",
  "motionWithdrawn": "Proposta ritirata",
  "budgetLocked": "Bilancio chiuso",
  "budgetUnlocked": "Bilancio sbloccato",
  "budgetCreated": "Bilancio creato",
  "noGovernanceEventsRecordedYet": "Nessun evento di governance registrato ancora.",
  "board": "Consiglio",
  "vote": "Vota:",
  "votingWindow": "Finestra di voto",
  "unit": "Unità",
  "hours": "ore",
  "days": "giorni",
  "weeks": "settimane",
  "months": "mesi",
  "setHowLongBoardVotingRemainsOpen": "Impostare il tempo di voto del consiglio rimane aperto.",
  "boardMembersWithMembersPortalAccess": "I membri del Consiglio con accesso al Portale dei Membri",
  "theseMembersWillVoteInsideTheMembersPortalVotingTab": "Questi soci voteranno all'interno della scheda di voto dei soci Portal.",
  "loadingRoster": "Caricamento roster...",
  "unableToLoadRoster": "Incapace di caricare roster.",
  "noPortalEnabledBoardMembersFound": "Nessun membro del forum abilitato al portale trovato.",
  "boardMembersWithoutMembersPortalAccess": "Membri del consiglio senza accesso al Portale dei membri",
  "theseMembersWillReceiveATemporaryVotingLinkAndOneTimeCodeViaEmail": "Questi soci riceveranno un link di voto temporaneo e un codice una volta via e-mail.",
  "noEmailOnFile": "Nessuna e-mail sul file",
  "everyoneHasPortalAccess": "Tutti hanno accesso al portale.",
  "resendVotingInvites": "Sostenere gli inviti di voto",
  "confirm": "Conferma",
  "votingPanel": "Pannello di Votazione",
  "pendingForOpenVotingOpenThisMotionToBeginBoardVoting": "In attesa di votazione aperta, aprite questa proposta per iniziare il voto del Consiglio.",
  "castYourVoteYourSelectionIsRecordedInstantly": "La tua selezione e' registrata all'istante.",
  "voteYes": "Votazioni Sì",
  "voteNo": "Vota no",
  "resolution": "Risoluzione",
  "approved": "Approvazione",
  "membersPortal": "Portale dei soci",
  "emailLinkOTP": "Link e-mail + OTP",
  "voters": "Voti",
  "loadingVoters": "Caricamento degli elettori...",
  "method": "Metodo",
  "lastSent": "Ultimo messaggio",
  "notVoted": "Non votato",
  "resendVotingLinkOTP": "Rimandare il link di voto + OTP",
  "noVotersFound": "Nessun elettore trovato.",
  "unableToLoadMotions": "Incapace di caricare i movimenti",
  "pleaseTryAgainInAFewMoments": "Si prega di riprovare in pochi istanti.",
  "openForVoting": "Aprire per la Votazione",
  "closedResolution": "Risoluzione chiusa",
  "withdrawnMotion": "Mozione ritirata",
  "viewResolution": "Visualizzazione della risoluzione",
  "reviewMotion": "Recensione del movimento",
  "votingAndResolutions": "Votazioni e delibere",
  "reviewBudgetMotionsOpenVotingAndRecordBoardDecisions": "Esaminare le proposte di bilancio, le votazioni aperte e le decisioni del consiglio di amministrazione.",
  "queuedForGMSecretaryRelease": "Queued per il rilascio GM/Segretario",
  "activeBoardDecisions": "Decisioni della commissione attiva",
  "loadingOpenMotions": "Caricamento di movimenti aperti...",
  "noMotionsAreCurrentlyOpenForVoting": "Non ci sono mozioni attualmente aperte per votare.",
  "closedMotions": "Movimenti chiusi",
  "finalizedResolutions": "Risoluzioni finalizzate",
  "loadingClosedMotions": "Caricamento di movimenti chiusi...",
  "noClosedMotionsYet": "Non ci sono ancora movimenti chiusi.",
  "refreshMotions": "Movimenti rinfrescanti",
  "draft": "Bozza",
  "open": "Apri",
  "closed": "Chiuso",
  "withdrawn": "Ritiro",
  "rejected": "Rifiuti",
  "viewAvatar": "Visualizza avatar per {name}",
  "memberStatus": "Stato attivo per {name}",
  "votedChoice": "Votato {choice}",
  "closesRelative": "Chiude {time}",
  "selectedWindow": "la finestra selezionata",
  "openedWindow": "Votare aperto — chiude in {window} .",
  "motionCountOne": "{count} movimento totale",
  "motionCountMany": "{count} mozioni totali",
  "yoy": "{percent} dello scorso anno",
  "other": "Altro",
  "uncategorized": "Non categorizzato",
  "unavailable": "Dati finanziari non disponibili. Si prega di riprovare più tardi.",
  "meetingLoadFailed": "Non è possibile caricare le riunioni. Si prega di riprovare.",
  "emailSubject": "Vota ora: {title}",
  "emailHeading": "Votazione del Consiglio ora aperta",
  "emailMotion": "Mozione:",
  "emailCloses": "Chiude:",
  "emailHelp": "Usa il link qui sotto per lanciare il tuo voto. Ti verrà chiesto il codice una volta.",
  "emailCode": "Codice una volta:",
  "emailDeadline": "Termine per la votazione",
  "missing_email": "E-mail mancante",
  "no_member_match": "Nessun record di socio corrispondente",
  "portal_access_disabled": "Accesso al portale disabili",
  "missing_auth0_id": "Portal account non disponibile",
  "loadingOpenVotes": "Caricamento di voti aperti...",
  "unableToLoadVotingMotions": "Incapace di caricare le mozioni di voto.",
  "boardVoting": "Votazione del Consiglio",
  "openMotions": "Movimenti aperti",
  "reviewCurrentMotionsAndCastYourVoteBeforeTheDeadline": "Rivedere le proposte attuali e lanciare il vostro voto prima della scadenza.",
  "noOpenMotionsRightNow": "Non ci sono mozioni aperte in questo momento.",
  "votes": "voti ·",
  "notYetVoted": "Non ancora votato",
  "reviewAndVote": "Rivedi e vota",
  "loadingMotion": "Caricamento in corso...",
  "unableToLoadMotionDetails": "Incapace di caricare i dettagli del movimento.",
  "motionReview": "Recensione del movimento",
  "opens": "Apre",
  "yourVoteNotRecordedYet": "Il tuo voto non è ancora registrato",
  "motionTotals": "Totale movimento",
  "votesSoFar": "Vota fino ad ora",
  "governanceTimeline": "Termine per la governance",
  "timelineUpdatesWillAppearHere": "Gli aggiornamenti della linea temporale verranno visualizzati qui.",
  "castYourVote": "Vota il tuo voto",
  "unableToRecordVotePleaseTryAgain": "Non riesco a registrare il voto, per favore riprova.",
  "boardVotingAccess": "Accesso al voto del Consiglio",
  "verifyYourVotingAccess": "Verifica l'accesso al voto",
  "thisVotingLinkIsMissingItsAccessToken": "Questo link di voto manca il suo accesso aken.",
  "enterYourOneTimeCode": "Inserisci il tuo codice una volta sola",
  "useTheCodeFromYourEmailToUnlockTheBallot": "Usa il codice dalla tua e-mail per sbloccare la scheda.",
  "6DigitCode": "codice a 6 cifre",
  "verifying": "Verificare...",
  "verify": "Verifica",
  "unableToVerifyTheCodePleaseTryAgain": "Non è possibile verificare il codice. Si prega di riprovare.",
  "motionDetails": "Dettagli del movimento",
  "votesRecorded": "Voti registrati:",
  "motionSubmitted": "Proposta sottoposta",
  "attendeeCountOne": "{count} partecipanti",
  "attendeeCountMany": "{count} partecipanti"
}
